import {config} from "../Config";

import {BaseSearchableService} from "./Core/BaseSearchableService";

let contactCache = {};

class ContactService extends BaseSearchableService {
    get Url() { return super.Url + "/contacts"; }
    get ModelName() { return "Contact"; }
    get PrimaryKeyProperty() { return "stakeholderId"; }
    get Request() {
        const organizationId = config.getStore().getState().contextState?.organizationId;

        return {...super.Request, organizationId};
    }

    GetTitle(model) {
        if(Number(model?.stakeholderTypeId ?? 1) === 1) {
            if(model?.firstName || model?.lastName) {
                return `${model.firstName ?? ''} ${model.lastName ?? ''}`;
            }
            return ''
        } else {
            return `${model?.organizationName ?? ""}`;
        }
        return "";
    }

    Get() {
        return this.SendRequest(BaseSearchableService.GET);
    }

    FindByName({ firstName, middleName, lastName, organizationName, organizationId }) {
        return this.SendRequest(BaseSearchableService.GET, { firstName, lastName, organizationName, organizationId });
    }
    
    GetProjectContacts(projectId) {
        let request = {projectId: projectId};
        return this.SendRequest(BaseSearchableService.GET, request);
    }

    GetContact(contactId, useCache = false) {
        if(useCache) {
            const cacheResult = contactCache[contactId];
            if(cacheResult) {
                //if this is a promise return that. So we don't spam the same contactId.
                if(cacheResult.then) {
                    return cacheResult;
                } else {
                    return new Promise((resolve, _) => {
                        resolve({
                            result: cacheResult
                        });
                    });
                }
            }
        }

        let ret = this.SendRequest(BaseSearchableService.GET, contactId);

        //cache promise until it resolves.
        contactCache[contactId] = ret;
        ret.then((x) => {
            contactCache[contactId] = x.result
        });

        return ret;
    }

    UpdateContact(contact) {
        return this.SendRequest(BaseSearchableService.PUT, contact);
    }

    CreateContact(contact) {
        return this.SendRequest(BaseSearchableService.POST, contact);
    }

    DeleteContact(contactId) {
        return this.SendRequest(BaseSearchableService.DELETE, contactId);
    }
}

export const service = new ContactService();

